import React, { useState } from 'react';
import classNames from 'classnames';
import {
  AudienceActiveFilters,
  LocalTagFilterItem,
} from './AudienceActiveFilters/AudienceActiveFilters';
import { LocalFilterItem } from '../../../../contacts/sharedFilterTypes';
import { AudienceFiltersMenu } from './AudienceFiltersMenu/AudienceFiltersMenu';
import { useFetchAudience } from '../use-fetch-audience';
import { useFetchAudienceVariables } from '../use-fetch-audience-variables';

type Props = {
  className?: string;
  audienceId: number;
};

export const AudienceFilters = (props: Props) => {
  const { className, audienceId } = props;
  const [showFilterMenu, setShowFilterMenu] = useState(false);
  const closeFilterMenu = () => setShowFilterMenu(false);
  const openFilterMenu = () => setShowFilterMenu(true);

  const onAddFilterBtnClick = () => {
    openFilterMenu();
    setFilterToEdit(undefined);
  };

  const [filterToEdit, setFilterToEdit] = useState<
    LocalFilterItem | LocalTagFilterItem | undefined
  >();

  const onEditFilterBtnClick = (
    filterOtTagFilter: LocalFilterItem | LocalTagFilterItem,
  ) => {
    openFilterMenu();
    setFilterToEdit(filterOtTagFilter);
  };

  const onDeleteFilterSuccess = () => setFilterToEdit(undefined);

  const onFilterAddSuccess = () => closeFilterMenu();
  const onFilterAddCancel = () => closeFilterMenu();

  useFetchAudience(audienceId);
  useFetchAudienceVariables();

  return (
    <div className={classNames(className)}>
      {showFilterMenu ? (
        <AudienceFiltersMenu
          audienceId={audienceId}
          onFilterAddSuccess={onFilterAddSuccess}
          onFilterAddCancel={onFilterAddCancel}
          filterToEdit={filterToEdit}
        />
      ) : (
        <AudienceActiveFilters
          audienceId={audienceId}
          onAddFilterBtnClick={onAddFilterBtnClick}
          onEditFilterBtnClick={onEditFilterBtnClick}
          onDeleteFilterSuccess={onDeleteFilterSuccess}
        />
      )}
    </div>
  );
};
